<script>
import checkoutMixin from '@/v-shop/checkout/checkout-mixin'

export default {
	lang: 'shop',
	mixins: [checkoutMixin],
	data() {
		return {
			options: null,
			selection: null,
		}
	},
	mounted() {
		const { items } = this.checkout.stepViewData || {}
		this.options =
			items
				?.map((item) => ({
					value: item.id,
					text: item.name,
				}))
				.sort((a, b) => (a.name < b.name ? -1 : 1)) || []
	},
	methods: {
		async submit() {
			if (this.selection) {
				await this.checkout.stepSubmit({ id: this.selection })
			}
		},
	},
}
</script>
<template>
	<div>
		<div class="font-2">Seleccioná el expreso por el cual enviaremos tu pedido</div>
		<Autocomplete
			class="mt-2"
			outlined
			:items="options"
			v-model="selection"
			placeholder="Buscar..."
		></Autocomplete>
		<div class="d-flex align-center justify-end py-2">
			<div><Button :disable="!selection" @click="submit" color="success">Continuar</Button></div>
		</div>
	</div>
</template>

